module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/todo-link.b231ac88.svg";